import { Box, Grid, Typography } from '@material-ui/core';
import React from 'react';

const Title = (props) => {
    const { title, button } = props;

    return (
        <Grid container spacing={0}>
            <Grid item lg={12} md={12} xs={12}>
                <Grid
                    container
                    direction="row"
                    justify="space-between"
                    alignItems="center"
                >
                    <Box>
                        <Typography variant="h2" component="h2" gutterBottom>
                            {title}
                        </Typography>
                    </Box>
                    <Box>{button}</Box>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default Title;
